import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const StepsLineComponent = (props) => {
  const { itemActive } = props;
  const [activeClass1, setActiveClass1] = useState(false);
  const [activeClass2, setActiveClass2] = useState(false);
  const [activeClass3, setActiveClass3] = useState(false);

  useEffect(() => {
    switch (itemActive) {
      case 1: {
        setActiveClass1(true);
        setActiveClass2(false);
        setActiveClass3(false);
        break;
      }
      case 2: {
        setActiveClass1(true);
        setActiveClass2(true);
        setActiveClass3(false);
        break;
      }
      case 3: {
        setActiveClass1(true);
        setActiveClass2(true);
        setActiveClass3(true);
        break;
      }
      default:
        setActiveClass1(false);
        setActiveClass2(false);
        setActiveClass3(false);
    }
  }, []);

  return (
    <div>
      <div className="steps-component pt-60 pb-15">
        <div className="step-1">
          <span className={`indicator ${activeClass1 ? 'active' : ''}`}>1</span>
        </div>
        <div className="step-2">
          <span className={`indicator ${activeClass2 ? 'active' : ''}`}>2</span>
        </div>
        <div className="step-3">
          <span className={`indicator ${activeClass3 ? 'active' : ''}`}>3</span>
        </div>
      </div>
      <div className="steps-texts">
        <span className="label">Mis Experiencias</span>
        <span className="label">Datos</span>
        <span className="label">Confirmación</span>
      </div>
    </div>
  );
};

StepsLineComponent.propTypes = {
  itemActive: PropTypes.number.isRequired,
};

export default StepsLineComponent;
